import { dataStarHalf } from 'dls-icons-data'
import { createIcon } from '../common'

const IconStarHalf = /*#__PURE__*/createIcon(dataStarHalf)
export default IconStarHalf
